import React from 'react';

export const Logo: React.FC<{ className?: string; withText?: boolean }> = ({ className = "", withText = true }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    {/* Kshetram Logo */}
    <svg width="30" height="35" viewBox="0 0 84 102" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0">
      <path d="M0.775024 51.5095L16.235 26.1795H83.265L67.805 51.5095H0.775024Z" fill="#58BA59"/>
      <path d="M0.775024 102.16L16.235 76.8295H83.265L67.805 102.16H0.775024Z" fill="#58BA59"/>
      <path d="M83.265 76.8295L67.805 51.5095H0.775024L16.235 76.8295H83.265Z" fill="#179246"/>
    </svg>
    
    {/* Text */}
    {withText && (
        <div className="flex flex-col">
            <div className="flex items-baseline gap-1">
                {/* <span className="text-xl font-bold leading-none text-gray-800 tracking-tight">Kshetram</span> */}
                <span className="text-lg font-medium text-gray-400 hidden sm:inline-block">क्षेत्रम्</span>
            </div>
        </div>
    )}
  </div>
);
